import type { RefObject } from 'react';
import { useState, useEffect } from 'react';

export const useChartDimensions = (
    containerRef: RefObject<HTMLDivElement | null>,
) => {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (!containerRef.current) return;

        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) {
                const { width, height } = entry.contentRect;
                setDimensions({ width, height });
            }
        });

        observer.observe(containerRef.current);

        return () => observer.disconnect();
    }, [containerRef]);

    return dimensions;
};
